import { Injectable } from '@angular/core';
import { StoreService } from 'app/store/store.service';
import { State } from '../../../store/reducers';
import { map } from 'rxjs/operators';
import * as menuActions from '../../../store/actions/Administracion/menus.actions';

@Injectable({
  providedIn: 'root'
})
export class SidebarFacadeService {

  constructor(private _store: StoreService<State>) { }

  //Selectores
  public Menus$ = this._store.state.pipe(map((state) => state.Menus?.menus));

  setearMenus(menus) {
    this._store.dispatch(new menuActions.GetMenus(menus));
  }
}
